function isDebugEnabled() {
  return window.location.search.match(/\bdebug\b/) != undefined
}

export function debug(message, data={}) {
  if (!isDebugEnabled()) {
    return
  }

  const formattedData = formatData(data)

  if (formattedData) {
    message = `${message} (${formattedData})`
  }

  console.log(message)
}

function formatData(data) {
  if (Object.keys(data).length == 0) {
    return
  }

  const parts = []

  for (const  [key, value] of Object.entries(data)) {
    const formattedKey = titleCase(key)
    const formattedValue = JSON.stringify(value)

    parts.push(`${formattedKey}: ${formattedValue}`)
  }

  return parts.join(", ")
}

function titleCase(text) {
  let titleCased = splitCamelCase(text)
  titleCased = capitalize(titleCased)

  return titleCased
}

function splitCamelCase(text) {
  return text.replace(/([A-Z])/g, " $1");
}

function capitalize(text) {
  return text.charAt(0).toUpperCase() + text.slice(1);
}
